<template>
  <div class="columns is-flex-centered p-2 has-border-radius has-border-light m-t-5">
    <span class="column is-9">
      <span class="is-size-5 has-text-primary has-text-weight-semibold is-relative is-full-width">
        <SkeletonView width="100%" height="40" />
      </span>
    </span>
    <div class="column is-3">
      <div class="columns is-full-width is-pulled-right">
        <div class="column is-5">
          <SkeletonView width="100%" height="30" />
        </div>
        <div class="column is-7">
          <SkeletonView width="100%" height="30" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DiagnosticToolLaunchCardSkeleton',
  components: { SkeletonView }
};
</script>
